import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { MigrationNotice } from './components/MigrationNotice'

const isOldProduction = String(import.meta.env.VITE_ENV ?? '').trim().toLowerCase() === 'old-prod';

// Aggressive cache clearing for both development and production
const clearAllCaches = async () => {
    try {
        console.log('🧹 Starting aggressive cache clearing...');

        // 1. Clear all browser caches
        if ('caches' in window) {
            const cacheNames = await caches.keys();
            console.log('📦 Found caches:', cacheNames);
            await Promise.all(
                cacheNames.map(async (cacheName) => {
                    const deleted = await caches.delete(cacheName);
                    console.log(`🗑️ Cache ${cacheName}: ${deleted ? 'deleted' : 'failed to delete'}`);
                    return deleted;
                })
            );
        }

        // 2. Unregister ALL service workers
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            console.log('🔧 Found service worker registrations:', registrations.length);
            await Promise.all(
                registrations.map(async (registration) => {
                    const unregistered = await registration.unregister();
                    console.log(`🔧 Service worker unregistered: ${unregistered}`);
                    return unregistered;
                })
            );
        }

        console.log('✅ Cache clearing completed');

        // 3. Force a hard reload after clearing (but not in development)
        if (!import.meta.env.DEV) {
            console.log('🔄 Forcing page reload to ensure fresh content...');
            window.location.reload();
        }

    } catch (error) {
        console.error('❌ Cache clearing failed:', error);
    }
};

// Check if we need to clear caches (run this always, not just in dev)
const shouldClearCaches = () => {
    // Clear caches if:
    // 1. URL has ?clear-cache=true, OR
    return window.location.search.includes('clear-cache=true')
};

// Initialize app
const initApp = async () => {
    if (shouldClearCaches()) {
        await clearAllCaches();
    }

    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            {isOldProduction ? <MigrationNotice /> : <App />}
        </React.StrictMode>,
    );

};

initApp();
